export default __webpack_public_path__ + "static/media/kid18.c60a2669.jpg";